import {
  getDisputeHistoryRecord as publicGetDisputeHistoryRecord,
  queryDisputeHistoryRecords as publicQueryDisputeHistoryRecords,
  typedQueryDisputeHistoryRecords as publicTypedQueryDisputeHistoryRecords,
  bulkUpdateDisputeHistoryRecordTags as publicBulkUpdateDisputeHistoryRecordTags,
  bulkUpdateDisputeHistoryRecordTagsByFilter as publicBulkUpdateDisputeHistoryRecordTagsByFilter,
} from './payments-dispute-history-records-v1-dispute-history-record-dispute-history-records.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  DisputeHistoryRecordQuery,
  DisputeHistoryRecordsQueryBuilder,
  typedQueryDisputeHistoryRecords as universalTypedQueryDisputeHistoryRecords,
} from './payments-dispute-history-records-v1-dispute-history-record-dispute-history-records.universal.js';

function customQueryDisputeHistoryRecords(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryDisputeHistoryRecords(httpClient)(),
    typedQueryFunction: (query: DisputeHistoryRecordQuery) =>
      publicTypedQueryDisputeHistoryRecords(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): DisputeHistoryRecordsQueryBuilder;
  function overloadedQuery(
    query: DisputeHistoryRecordQuery
  ): ReturnType<typeof universalTypedQueryDisputeHistoryRecords>;
  function overloadedQuery(query?: DisputeHistoryRecordQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const getDisputeHistoryRecord: MaybeContext<
  BuildRESTFunction<typeof publicGetDisputeHistoryRecord> &
    typeof publicGetDisputeHistoryRecord
> = /*#__PURE__*/ createRESTModule(publicGetDisputeHistoryRecord);
export const bulkUpdateDisputeHistoryRecordTags: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateDisputeHistoryRecordTags> &
    typeof publicBulkUpdateDisputeHistoryRecordTags
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateDisputeHistoryRecordTags);
export const bulkUpdateDisputeHistoryRecordTagsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateDisputeHistoryRecordTagsByFilter> &
    typeof publicBulkUpdateDisputeHistoryRecordTagsByFilter
> = /*#__PURE__*/ createRESTModule(
  publicBulkUpdateDisputeHistoryRecordTagsByFilter
);
export const queryDisputeHistoryRecords: MaybeContext<
  BuildRESTFunction<typeof customQueryDisputeHistoryRecords> &
    typeof customQueryDisputeHistoryRecords
> = /*#__PURE__*/ createRESTModule(customQueryDisputeHistoryRecords);

export {
  DisputeStage,
  DisputeStatus,
  DisputeChannel,
  SortOrder,
  WebhookIdentityType,
} from './payments-dispute-history-records-v1-dispute-history-record-dispute-history-records.universal.js';
export {
  DisputeHistoryRecord,
  ExtendedFields,
  Tags,
  TagList,
  TagsModified,
  GetDisputeHistoryRecordRequest,
  GetDisputeHistoryRecordResponse,
  QueryDisputeHistoryRecordsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryDisputeHistoryRecordsResponse,
  CursorPagingMetadata,
  Cursors,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  BulkUpdateDisputeHistoryRecordTagsRequest,
  BulkUpdateDisputeHistoryRecordTagsResponse,
  ItemMetadata,
  ApplicationError,
  BulkUpdateDisputeHistoryRecordTagsResult,
  BulkActionMetadata,
  BulkUpdateDisputeHistoryRecordTagsByFilterRequest,
  BulkUpdateDisputeHistoryRecordTagsByFilterResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  DisputeHistoryRecordsQueryResult,
  DisputeHistoryRecordsQueryBuilder,
  DisputeHistoryRecordQuerySpec,
  BulkUpdateDisputeHistoryRecordTagsOptions,
  BulkUpdateDisputeHistoryRecordTagsByFilterOptions,
} from './payments-dispute-history-records-v1-dispute-history-record-dispute-history-records.universal.js';
export { utils } from './payments-dispute-history-records-v1-dispute-history-record-dispute-history-records.universal.js';
export {
  DisputeStageWithLiterals,
  DisputeStatusWithLiterals,
  DisputeChannelWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  BulkUpdateDisputeHistoryRecordTagsApplicationErrors,
  BulkUpdateDisputeHistoryRecordTagsByFilterApplicationErrors,
  CommonQueryWithEntityContext,
  DisputeHistoryRecordQuery,
} from './payments-dispute-history-records-v1-dispute-history-record-dispute-history-records.universal.js';
